export const mapArrayToObj = (data) =>
	data.reduce(
		(prev, current) => ({
			...prev,
			[current.id]: current,
		}),
		{}
	);

export const roles = {
	ADMIN: 'admin',
	SUPERVISOR: 'supervisor',
	SUPER_ADMIN: 'superAdmin',
	AGENT: 'agent',
};
